import { render, staticRenderFns } from "./LabaRugi.vue?vue&type=template&id=ec3241d8&scoped=true&"
import script from "./LabaRugi.vue?vue&type=script&lang=js&"
export * from "./LabaRugi.vue?vue&type=script&lang=js&"
import style0 from "./LabaRugi.vue?vue&type=style&index=0&id=ec3241d8&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ec3241d8",
  null
  
)

export default component.exports